import { isAuthorizedUser } from 'shared/hooks/use-user'
import { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'

export const shouldShowChangePasswordPage = (
  user: UserInterface | UnauthorizedUser | undefined,
): boolean => {
  return isAuthorizedUser(user) && !user.impersonator
}
